// Function to get the base URL based on environment query parameter
export function getBaseUrl(): string {
  const params = new URLSearchParams(window.location.search);
  const env = params.get('env');
  const ap = params.get('ap');

  // Validate ap parameter - only 'a' or 'b' are valid
  const validAp = ap === 'a' || ap === 'b' ? ap : null;
  if (env === 'local') {
    return 'http://localhost:3003/a/';
  }
  if (env === 'qa') {
    const baseUrl = 'https://qa-site-api.getpoln.com/';
    return validAp ? `${baseUrl}${validAp}/` : baseUrl;
  }
  // Default to production
  const baseUrl = 'https://site-api.getpoln.com/';
  return validAp ? `${baseUrl}${validAp}/` : baseUrl;
}